class BarWaitlist extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('[data-bar-waitlist-dialog]');
    this.form = this.querySelector('[data-bar-waitlist-form]');
    this.status = this.querySelector('[data-bar-waitlist-status]');
    this.submitBtn = this.querySelector('.bar-waitlist__submit');
    this.done = this.querySelector('[data-bar-waitlist-done]');
    this.img = this.querySelector('[data-bar-waitlist-img]');

    const trigger = this.querySelector('[data-bar-waitlist-open]');
    trigger.addEventListener('click', () => this.open());
    /* la foto de la ventana empieza a bajar apenas el dedo o el mouse se acerca al botón */
    const warm = () => { if (this.img) this.img.loading = 'eager'; };
    trigger.addEventListener('pointerenter', warm, { once: true });
    trigger.addEventListener('touchstart', warm, { once: true, passive: true });
    trigger.addEventListener('focus', warm, { once: true });

    this.querySelectorAll('[data-bar-waitlist-close]').forEach((btn) => btn.addEventListener('click', () => this.close()));
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.close();
    });
    this.dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      this.close();
    });
    this.form.addEventListener('submit', (event) => this.handleSubmit(event));

    /* En la PDP sigue la variante elegida: se muestra solo si esa variante está
       sin stock, y anota el acabado (ej. "Barra de Estáticos BÄR - Metal"). */
    if (this.hasAttribute('data-follow-variant') && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, (event) => this.onVariantChange(event));
    }
  }

  disconnectedCallback() {
    if (this.unsubscribeVariant) this.unsubscribeVariant();
    /* la ventana se mudó al body al abrirla: si el bloque desaparece, se va con él */
    if (this.dialog && this.dialog.parentElement === document.body && !this.contains(this.dialog)) this.dialog.remove();
  }

  onVariantChange(event) {
    if (!event || !event.data || event.data.sectionId !== this.dataset.sectionId) return;
    const variant = event.data.variant;
    this.hidden = Boolean(variant && variant.available);
    if (!variant) return;
    const title = variant.title && variant.title !== 'Default Title' ? `${this.dataset.baseTitle} - ${variant.title}` : this.dataset.baseTitle;
    this.dataset.productTitle = title;
    this.dataset.productUrl = `${this.dataset.baseUrl}?variant=${variant.id}`;
    [this, this.dialog].forEach((root) => root.querySelectorAll('[data-bar-waitlist-product], [data-bar-waitlist-product-name]').forEach((el) => { el.textContent = title; }));
    const media = variant.featured_media && variant.featured_media.preview_image;
    if (this.img && media && media.src) {
      const src = media.src.replace(/^https?:/, '');
      this.img.srcset = [450, 700, 900].map((w) => `${src}${src.includes('?') ? '&' : '?'}width=${w} ${w}w`).join(', ');
      this.img.src = `${src}${src.includes('?') ? '&' : '?'}width=900`;
    }
  }

  open() {
    /* Safari de iPhone: si la ventana queda adentro de un bloque con transform (la animación de entrada del tema),
       muestra el fondo oscuro pero no la ventana. Colgada directo del body se ve siempre. */
    if (this.dialog.parentElement !== document.body) document.body.appendChild(this.dialog);
    this.dialog.classList.remove('is-closing');
    if (typeof this.dialog.showModal === 'function') {
      this.dialog.showModal();
    } else {
      this.dialog.setAttribute('open', '');
    }
    /* en escritorio el cursor va directo al primer campo; en el celular no, para no tapar la ventana con el teclado */
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      const first = this.form.querySelector('input');
      if (first && !this.form.hidden) first.focus({ preventScroll: true });
    }
  }

  close() {
    if (!this.dialog.open || this.dialog.classList.contains('is-closing')) return;
    const finish = () => {
      this.dialog.classList.remove('is-closing');
      if (typeof this.dialog.close === 'function') {
        this.dialog.close();
      } else {
        this.dialog.removeAttribute('open');
      }
      this.reset();
    };
    this.dialog.classList.add('is-closing');
    let ended = false;
    const end = () => { if (!ended) { ended = true; finish(); } };
    this.dialog.addEventListener('animationend', end, { once: true });
    window.setTimeout(end, 320);
  }

  reset() {
    this.setStatus('');
    this.form.hidden = false;
    this.form.reset();
    this.form.classList.remove('was-validated');
    this.done.hidden = true;
    this.done.parentElement.classList.remove('is-done');
    this.setLoading(false);
  }

  /* Los mensajes llegan traducidos por data-attributes desde bar-waitlist.liquid:
     un asset .js no pasa por Liquid y no puede usar el filtro t. El segundo
     argumento es el fallback en español por si falta la clave. */
  text(key, fallback) {
    return this.dataset['i18n' + key.charAt(0).toUpperCase() + key.slice(1)] || fallback;
  }

  setStatus(message, isError) {
    this.status.textContent = message;
    this.status.classList.toggle('is-error', Boolean(isError));
  }

  setLoading(on) {
    this.submitBtn.disabled = on;
    this.submitBtn.classList.toggle('is-loading', on);
    this.submitBtn.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  handleSubmit(event) {
    event.preventDefault();
    this.form.classList.add('was-validated');
    if (!this.form.checkValidity()) {
      const bad = this.form.querySelector(':invalid');
      if (bad) bad.focus();
      this.form.reportValidity();
      return;
    }

    const webhookUrl = this.dataset.webhookUrl;
    if (!webhookUrl) {
      this.setStatus(this.text('notConfigured', 'La lista de espera todavía no está configurada.'), true);
      return;
    }

    const formData = new FormData(this.form);
    const payload = {
      nombre: formData.get('nombre').trim(),
      email: formData.get('email').trim(),
      telefono: formData.get('telefono').trim(),
      producto: this.dataset.productTitle,
      url: this.dataset.productUrl,
      fecha: new Date().toISOString(),
    };

    this.setLoading(true);
    this.setStatus('');

    fetch(webhookUrl, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload),
    })
      .then(() => {
        this.form.hidden = true;
        this.dialog.querySelector('[data-bar-waitlist-done-text]').textContent = this.text('success', '¡Listo! Ya estás en la lista de espera. Te escribimos cuando sea tu turno.');
        this.done.hidden = false;
        this.done.parentElement.classList.add('is-done');
        const btn = this.done.querySelector('button');
        if (btn) btn.focus({ preventScroll: true });
      })
      .catch(() => {
        this.setStatus(this.text('error', 'Hubo un error. Probá de nuevo en un rato.'), true);
        this.setLoading(false);
      });
  }
}

customElements.define('bar-waitlist', BarWaitlist);
